module.exports = new __parcel__URL__("no-results-dark.5b9fe043.svg").toString();